import { RunWorkflowArgs } from '@/app/workflows/actions/interfaces';
import { cloudApiClient } from '@/services/clientSideCloudApiService';

export const runWorkflow = async function (args: RunWorkflowArgs) {
  return await cloudApiClient.post('rawmodel/optimize', args);
};
